module.exports = __webpack_public_path__ + "img/border.23809892.png";